<div class="pb-30">
  <div class="header-style">
    <div class="h-100">
      @if (user.type === utils.userTypes.Distributor || user.type === utils.userTypes.DistributorChild) {
        <mat-form-field appearance="outline" class="select">
          <mat-select data-testid="usedOnMobile_filter" (selectionChange)="filterChange($event.value)" [(value)]="selected" #usedOnMobile_filter  id="usedOnMobile_filter"
            name="usedOnMobile_filter">
            <mat-option i18n="@@PositioningUsedonmobile" value="usedOnMobile">Positioning Used on mobile</mat-option>
            <mat-option i18n="@@PositioningToPickFrom" value="manufacturer">Positioning To Pick From</mat-option>
          </mat-select>
        </mat-form-field>
      }
    </div>
    <div class="d-flex justify-content-center align-items-center">
      <mat-paginator i18n-aria-label="@@paginator" [length]="totalSize" [pageSize]="pageSize" [pageIndex]="pageNumber - 1" [pageSizeOptions]="[10, 20, 50, 100]" (page)="handlePage($event)"></mat-paginator>
      
      @if (user.type !== utils.userTypes.Admin) {
        <mat-icon data-testid="add_positioning_button" (click)="openAddPositioning()" class="cursor add-icon"  svgIcon="add" i18n-label="@@addPositioningIcon" aria-label="Add positioning"></mat-icon>
      }

      <form [formGroup]="searchForm" (ngSubmit)="doSearch()">
        @if (showSearch) {
          <mat-form-field class="search-field">
            <mat-label i18n="@@searchLabel">Search</mat-label>
            <input i18n-placeholder="@@searchPlaceholder" data-testid="positioning_search_input" matInput formControlName="search" id="search" placeholder="Search" name="search"/>
            <mat-icon data-testid="positioning_clear_button" class="cursor" matSuffix (click)="clearSearch()" i18n-label="@@clearSearchIcon" aria-label="Clear search">clear</mat-icon>
          </mat-form-field>
        }
      </form>

      <mat-icon data-testid="positioning_search_button" (click)="handleSearchClick()" class="cursor" svgIcon="search" i18n-label="@@searchIcon" aria-label="Search"></mat-icon>
    </div>
  </div>

  @for (item of positioningList; track item; let itemIndex = $index) {
    <mat-card class="simple-card cursor">
      <mat-card-content>
        <div class="flex-grow d-flex justify-content-between cursor">
          <div class="flex-grow" (click)="openChallengeDetails(item)">
            <div class="mat-subtitle-1 mb-12" matTooltip ellipsisTooltip>{{item.competitorChallenge}}</div>
            <div class="mat-caption" matTooltip ellipsisTooltip>{{item.productOffer}}</div>
          </div>

          @if (user.type === utils.userTypes.Manufacturer || user.type === utils.userTypes.ManufacturerChild) {
            <mat-icon class="cursor" [matMenuTriggerFor]="menu" color="accent" i18n-label="@@moreOptionsIcon" aria-label="More options">more_vert</mat-icon>
          }

          @if ((user.type === utils.userTypes.Distributor || user.type === utils.userTypes.DistributorChild) && selected === 'manufacturer') {
            <mat-icon class="{{item.usedOnMobile ? 'cursor header-icon' : 'header-icon-color cursor'}}" 
                      (click)="item.usedOnMobile ? moveToNotUsedOnMobile(item.id) : moveToUsedOnMobile(item.id)" 
                      i18n-label="@@toggleUsedOnMobileIcon" 
                      aria-label="Toggle used on mobile">
              stay_current_portrait
            </mat-icon>
          }

          @if ((user.type === utils.userTypes.Distributor || user.type === utils.userTypes.DistributorChild) && selected === 'usedOnMobile' && item.isAddedByManufacturer === true) {
            <mat-icon class="cursor header-icon" (click)="moveToNotUsedOnMobile(item.id)" i18n-label="@@removeUsedOnMobileIcon" aria-label="Remove used on mobile">stay_current_portrait</mat-icon>
          }

          @if ((user.type === utils.userTypes.Distributor || user.type === utils.userTypes.DistributorChild) && selected === 'usedOnMobile' && item.isAddedByManufacturer === false) {
            <mat-icon class="cursor" [matMenuTriggerFor]="menu" color="accent" i18n-label="@@moreOptionsIcon" aria-label="More options">more_vert</mat-icon>
          }
        </div>

        <mat-menu #menu="matMenu">
          <button i18n="@@edit" data-testid="edit_positioning_button" (click)="editPositioning(item)" mat-menu-item>Edit</button>
          <button i18n="@@delete" data-testid="delete_positioning_button" (click)="deletePositioning(item.id)" mat-menu-item>Delete</button>
        </mat-menu>
      </mat-card-content>
    </mat-card>
  }
  @if (positioningList.length === 0) {
    <img class="empty-view-img" src="{{utils.isDarkMode() ? '../../../assets/images/empty-view-dark.svg' : '../../../assets/images/empty-view.svg'}}" i18n-alt="@@emptyViewImage" alt="No positioning available">
  }
</div>